// extracted by mini-css-extract-plugin
module.exports = {"quantity_counter":"quantityCounter_quantity_counter__2rK55","button":"quantityCounter_button__2-gs2","input":"quantityCounter_input__1sCVb"};